var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',[_c('PitchEnglishHomeApplicationTemplate',[_c('router-view'),_c('pending-surveys-prompt',{attrs:{"profile":"customer"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }